import { Container } from "@sainsburys-tech/luna-grid";
import { BreadcrumbsItem, BreadcrumbsWrapper } from "@sainsburys-tech/luna-breadcrumbs";
import { useEffect, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import SearchForm from "../../SearchForm/SearchForm";
import { initialValueOfFamilyGroupModel } from "../../../Models/FamilyGroupModel";
import Management from "../Management/management";
import { useSelector } from "react-redux";
import DataTable from "./DataTable";
import { ValuesType } from "../../../Types/InitialStateType";

const ContainerTypeMaintenanceSearch = () => {
  //const [filters, setFilters] = useState("")
  const [breadCrumb, setBreadCrumb] = useState(false);
  const [disableSearchForm, setDisableSearchForm] = useState(false);
  const [createButton, setCreateButton] = useState(false);
  const [dataTablePayload, setDataTablePayload] = useState();

  const history = useHistory();
  const location = useLocation();
  const { data, isDirectQuery, parentName, selectedMenu } = useSelector(
    (state: any) => state.filterReducer.data
  );
  const payload = useSelector((state: any) => state.dataTableReducer);

  useEffect(() => {
    setDataTablePayload(payload);
  }, []);

  let valuesType: ValuesType[] = [{
    name: "Search",
    label: "Search",
    value: "",
    searchMethod: "contains",
    searchOperator: "or"
  }];
  
  const initialState = {
    values: valuesType,
    submitted: false,
    dirty: false,
  };

  const toggleSearch = (isDisabled: boolean) => {
    setDisableSearchForm(isDisabled);
  };

  useEffect(() => {
    setCreateButton(selectedMenu === "Management");
  }, [selectedMenu]);
  return (
    <>
      <Container className="containerPanelFullHeight" soft data-test="add">
        {breadCrumb && (
          <BreadcrumbsWrapper>
            <BreadcrumbsItem>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  history.push("/familyGroupAdmin");
                }}
              >
                Container Type Maintenance
              </a>
            </BreadcrumbsItem>
            <BreadcrumbsItem active>Container Type Maintenance</BreadcrumbsItem>
          </BreadcrumbsWrapper>
        )}

        <h4 style={{ display: "inline" }}>Container Type Maintenance</h4>
        <span className="orangeSainsburysAction"> | </span>
        <span className="orangeSainsburysAction">{selectedMenu}</span>

        <SearchForm
          initialState={initialState}
          isDisabled={disableSearchForm}
          //setFilters={setFilters}
          model={initialValueOfFamilyGroupModel}
          hasCreateButton={createButton}
        />

        <Switch>
          <Route path={`/containerTypeMaintenance/management`}>
            <Management toggleSearchPanel={toggleSearch} />
          </Route>
        </Switch>

        {dataTablePayload && (
          <Container
            className="gridContainer containerPanelFullWidthWithWhiteBKG"
            soft
          >
            <DataTable
              service={payload.data.service}
              columnDefinition={payload.data.columnDefinition}
              toggleSearchPanel={payload.data.toggleSearchPanel}
            />
          </Container>
        )}
      </Container>
    </>
  );
};
export default ContainerTypeMaintenanceSearch;
